// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { theme } from '@tectonics/look-and-feel/uber-v2/theme';
import { PlaceOrderButtonPix } from '@tectonics/look-and-feel/uber-v2/page-payment-opened/form/place-order-button';


export function PixPaymentInformation(): Node {
  return (
    <Root>
      <ChildrenWrapper>
        <DisplayInformation>
          <Title>Não encontrou seu banco?</Title>
          <p><strong>Você ainda pode pagar com PIX!</strong> Copie o código abaixo para realizar o pagamento na área PIX do App de sua preferência.</p>
        </DisplayInformation>
        <PlaceOrderButtonPix />
      </ChildrenWrapper>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: 80%;
  margin: auto;
`;

const ChildrenWrapper = styled.div`
  border: 1px solid #c5c5c5;
  border-radius: 3px;
  font-family: ${theme.fontFamily.sansSerif};
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  align-items: center;
  text-align: center;
  color: #333333;
  margin: 5px auto 5px;
  padding: 16px;
`;

const DisplayInformation = styled.div`
  margin-bottom: 16px;
`;

const Title = styled.h1`
  font-weight: 700;
  padding-bottom: 5px;
`;
